module.exports = __webpack_public_path__ + "img/preview-1.5bb5c138.png";